export default __webpack_public_path__ + "static/image_les_suites_s@2x-b558d12764a7c09ce83de1497a70db8b.jpg";